"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("./curry.js");

var every = require("./every.js");

module.exports = curry(function satisfiesEvery(fns, ...args) {
  return every(f => f(...args), fns);
});